import Handlebar from '@/grpc-api/model/handlebar';
import i18n from '@/plugins/i18n';
import store from '@/store/store';
import { computed } from 'vue';

export const useHandlebars = computed<Handlebar[]>(() => store.state.messageCenter.handlebars);

export const useHandlebarPlaceholders = computed(() => {
  const handlebars = useHandlebars.value.map((o) => ({ id: o.id, name: i18n.tc(`code.handlebar.${o.name}`) }));
  return handlebars;
});
